import { createDomain, sample } from 'effector';
import { type Location } from 'react-router-dom';

import { QSToObject } from 'utils/common-helper';

const domain = createDomain('location');

export const $location = domain.store<Location>({ pathname: '', search: '', hash: '', state: null, key: '' });
export const $pathname = domain.store<string>('');
export const $queryParams = $location.map((location) => QSToObject(location.search || '?'));

export const $isDocumentPage = domain.store<boolean>(false);
export const $isPaymentPage = domain.store<boolean>(false);
export const $isTacPage = domain.store<boolean>(false);
export const $isSummaryPage = domain.store<boolean>(false);
export const $isAdvisorClientsListPage = domain.store<boolean>(false);
export const $isAdvisorClientPage = domain.store<boolean>(false);
export const $isAdvisorGroupPage = domain.store<boolean>(false);
export const $isAdvisorPanel = domain.store<boolean>(false);
export const $isSignupPage = domain.store<boolean>(false);
export const $isDashboard = domain.store<boolean>(false);
export const $isCommunity = domain.store<boolean>(false);
export const $isEmployersPage = domain.store<boolean>(false);
export const $isValidationPage = domain.store<boolean>(false);
export const $isTrustFundingPage = domain.store<boolean>(false);
export const $isGiftTrustPage = domain.store<boolean>(false);
export const $isDocsGenerationPage = domain.store<boolean>(false);
export const $isPrePaymentPage = domain.store<boolean>(false);

export const $isHeaderlessPage = sample({
    source: [$isDocumentPage, $isPaymentPage, $isSummaryPage],
    fn: (headerlessPages) => headerlessPages.some(Boolean),
});

export const setParams = domain.effect<{ [key: string]: any }, void>();
export const clearParams = domain.effect(() => {});
export const setByKey = domain.effect<{ key: string; value: any }, void>();
